import React, { Dispatch, SetStateAction } from 'react';
import { Button } from '@mui/material';

import {
  deviceFilter,
  SiteTypes,
} from '@src/utils/defaultDataStubs/stubFilters';
import { CollectionPayload } from '@src/types/Collection';
import FormattedAlias from '@src/components/_shared/Translations/FormattedAlias';

interface Props {
  setOpen: Dispatch<SetStateAction<boolean>>;
  setJsonPayload: Dispatch<SetStateAction<CollectionPayload | null>>;
}

function CreateDeviceButton({
  setJsonPayload,
  setOpen,
}: Props): React.ReactElement {
  const json = deviceFilter(
    sessionStorage.getItem('siteType')
      ? (sessionStorage.getItem('siteType') as SiteTypes)
      : null,
  );
  const handleGenerateDevicesClick = () => {
    setJsonPayload(json);
    setOpen(true);
  };

  return (
    <Button
      component='label'
      variant='contained'
      onClick={handleGenerateDevicesClick}
    >
      <FormattedAlias id='Create Device' />
    </Button>
  );
}

export default CreateDeviceButton;
